import { useParams } from 'react-router-dom';

import { AppGeneralSettingsPage } from '~/components/pages/AppGeneralSettingsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppGeneralSettingsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppGeneralSettingsPage appId={appId} />
    </DashboardTemplate>
  );
};
